import useQuery from '@/core/hooks/useQuery/useQuery';

export default useQuery;
